// src/index.tsx
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import 'antd/dist/antd.min.css';

import Router from "./router";
import i18n from "./translation";
import CookieConsent, { ConsentPreferences } from "./components/CookieConsent";
import SEO from "./components/SEO";

const App = () => {
  const handleCookieConsent = (preferences: ConsentPreferences) => {
    // Here you can implement logic to respect cookie preferences
    // For example, only initialize analytics if preferences.analytics is true
    if (preferences.analytics) {
      // Initialize analytics (Google Analytics, etc.)
      console.log('Analytics initialized');
      
      // Example: Initialize Google Analytics
      // if (typeof window.gtag !== 'undefined') {
      //   window.gtag('consent', 'update', {
      //     'analytics_storage': 'granted'
      //   });
      // }
    } else {
      console.log('Analytics not initialized due to user preferences');
      
      // Example: Disable Google Analytics
      // if (typeof window.gtag !== 'undefined') {
      //   window.gtag('consent', 'update', {
      //     'analytics_storage': 'denied'
      //   });
      // }
    }
  };

  return (
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <SEO />
        <Router />
        <CookieConsent onAccept={handleCookieConsent} />
      </I18nextProvider>
    </BrowserRouter>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));